import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Login } from '../../components';
import { HomeScreen, ItemsScreen, ConsumeScreen, ViewHealthScreen, ViewGraphScreen } from '../../components/usr';

function App() {
    return (
        <div className="App">
            <div className="content">
                <Routes>
                    <Route path="/" element={<HomeScreen />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/items" element={<ItemsScreen />} />
                    <Route path="/consume" element={<ConsumeScreen />} />
                    <Route path="/home" element={<HomeScreen />} />
                    <Route path="/health" element={<ViewHealthScreen />} />
                    <Route path="/graph" element={<ViewGraphScreen />} />
                </Routes>
            </div>
        </div>
    )
}

export default App;
